// 모든 날짜 계산을 한국 시간대(KST, Asia/Seoul) 기준으로 통일하기 위한 헬퍼.
// 브라우저 로컬 시간대와 무관하게 항상 한국 날짜를 반환한다.

// 오늘 날짜를 'YYYY-MM-DD' (KST) 문자열로 반환
export const todayStr = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Seoul' });

// 'YYYY-MM-DD' 날짜에 days 일을 더해 'YYYY-MM-DD' 로 반환 (UTC 기준 순수 달력 계산 — 시간대 무관)
export const datePlusDays = (baseStr, days) => {
  const d = new Date(`${baseStr || todayStr()}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
};

// n일 전 날짜를 'YYYY-MM-DD' (KST) 로 반환
export const daysAgoStr = (n) => datePlusDays(todayStr(), -n);

// 두 'YYYY-MM-DD' 날짜 사이의 일수 차이 (b - a) — 시간대 무관
export const daysBetween = (a, b) =>
  Math.round((new Date(`${b}T00:00:00Z`) - new Date(`${a}T00:00:00Z`)) / 86400000);

// 목록용 일자 표시 (KST 기준): 올해면 'm월 d일', 다른 연도면 'y년 m월 d일' (공백 통일). 값이 없거나 잘못되면 ''
export const fmtListDate = (v) => {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d.getTime())) return '';
  const [y, m, day] = d.toLocaleDateString('en-CA', { timeZone: 'Asia/Seoul' }).split('-').map(Number);
  return y === Number(todayStr().slice(0, 4)) ? `${m}월 ${day}일` : `${y}년 ${m}월 ${day}일`;
};
